import Head from 'next/head'

interface OGMetaTagsProps {
  title: string
  description: string
  url?: string
  urlRel?: 'canonical' | 'nofollow'
  type?: 'website' | 'product' | 'article'
  productData?: {
    retailerPartNo: string
    price?: number | null
    salePrice?: number | null
    orginalPrice?: number | null
    availability?: 'in stock' | 'out of stock'
    brand?: string
    condition?: 'new' | 'used' | 'refurbished'
    category?: string
  }
  imageData?: {
    url?: string
    alt?: string
  }
}

const PageMeta = ({
  title,
  description,
  url,
  type = 'website',
  productData,
  urlRel = 'canonical',
  imageData
}: OGMetaTagsProps) => {
  // Format price to string with 2 decimal places
  const formatPrice = (price?: number) => {
    if (!price) return undefined

    return price.toFixed(2)
  }

  return (
    <Head>
      <title>{title}</title>
      <meta name='description' content={description} />
      <link rel={urlRel} href={url} />
      {/* Basic Open Graph tags */}
      <meta property='og:title' content={title} />
      <meta property='og:description' content={description} />
      {imageData?.url && (
        <>
          <meta property='og:image' content={imageData.url} />

          {imageData?.alt && (
            <meta property='og:image:alt' content={imageData.alt} />
          )}
        </>
      )}
      <meta property='og:url' content={url} />
      <meta property='og:type' content={type} />
      <meta property='og:site_name' content='Lokalny Rolnik' />

      {/* Product specific tags */}
      {type === 'product' && productData && (
        <>
          <meta
            property='product:retailer_part_no'
            content={productData.retailerPartNo}
          />
          {productData.price && (
            <meta
              property='product:price:amount'
              content={formatPrice(productData.price)}
            />
          )}
          {productData.salePrice && (
            <meta
              property='product:sale_price:amount'
              content={formatPrice(productData.salePrice)}
            />
          )}
          {productData.orginalPrice && (
            <meta
              property='product:original_price:amount'
              content={formatPrice(productData.orginalPrice)}
            />
          )}

          <meta property='product:price:currency' content='PLN' />

          {productData.availability && (
            <meta
              property='product:availability'
              content={productData.availability}
            />
          )}
          {productData.brand && (
            <meta property='product:brand' content={productData.brand} />
          )}
          {productData.condition && (
            <meta
              property='product:condition'
              content={productData.condition}
            />
          )}
          {productData.category && (
            <meta property='product:category' content={productData.category} />
          )}
        </>
      )}
    </Head>
  )
}

export default PageMeta
